import * as React from 'react';
import classNames from 'classnames';
import './Badge.scss';

export type BadgeProps = {
  children?: any;
  className?: string;
  color?: 'white' | 'black' | 'dark' | 'smoke-white' | 'dark-blue' | 'blue' | 'danger' | 'warning' | 'success';
  size?: 'micro' | 'mini' | 'small' | 'large';
  round?: boolean;
}

type HTMLDIVElementWithoutSize = Omit<React.HTMLProps<HTMLDivElement>, 'size'>

const Badge = ({ children, className, color, size, round, ...props }: BadgeProps & HTMLDIVElementWithoutSize) => (
  <div
    className={classNames(
      'badge',
      className,
      color && `is-${color}`,
      size && `is-${size}`,
      round && 'is-round'
    )}
    {...props}
  >
    {children}
  </div>
);

export default Badge;



// WEBPACK FOOTER //
// ./src/components/Badge/index.tsx